

    import Vue from 'vue';
    import {mapState} from "vuex";
    import RomaPercentage from "@/components/commons/RomaPercentage.vue";
    import { ChevronDownIcon, ChevronUpIcon, ArrowLeftIcon } from 'vue-feather-icons';
    import moment from 'moment';
    // Components
    import RomaMessageModal from "../commons/RomaMessageModal.vue";
    // Store
    import UnitPlanComments from "@/store/units/UnitPlanComments";
    import UnitPlan from "@/store/units/UnitPlan";
    // Interfaces
    import {IUnitPlan} from "@/interfaces/units/IUnitPlan";
    import {IPrivileges} from "@/interfaces/commons/IPrivileges";

    export default Vue.extend({
        name: 'RomaUnit',
        mounted () {
            this.expanded = this.expand;
        },
        props: {
            md: { // Propiedad que mueve el tamaño en "display medium" de la primera columna/celda del componente
                type: Number,
                default: 7
            },
            unit: {
                type: Object,
                required: true,
            },
            expand: {
                type: Boolean,
                default: true,
            },
            menu: {
                type: Array,
                default() {
                    return [
                        {label: 'Editar', action: null, route: null},
                        {label: 'Eliminar', action: null, route: null},
                        {label: 'Vista detalles', action: null, route: null},
                    ];
                },
            },
            index: Number,
        },
        data() {
            return {
                expanded: true,
                userPrivileges: this.$store.state.user.privileges as IPrivileges,
                showCommentsModal: false,
                filterBy: {
                    field: '',
                    value: 0,
                },
                parcialRequest: {
                    idPlanUnidadOA: 0,
                    idPlanUnidad: 0,
                },
            };
        },
        computed: {
            rowMd () {
                if (!this.expanded) return 12;
                else return this.md;
            },
            ...mapState([
                'user'
            ]),
            getCountComments(): number {
                return UnitPlanComments.query()
                    .where('idPlanUnidad', this.unit.id)
                    .where('tipoComentario', 'Manual')
                    .count();
            },
            getUnitPlan(): IUnitPlan {
                const unitPlan = UnitPlan.query()
                    .where('id', this.unit.id)
                    .withAll()
                    .first();
                return unitPlan;
            },
        },
        methods: {
            showComments() {
                this.showCommentsModal = true;
                this.parcialRequest = {
                    idPlanUnidad: this.unit.id,
                };
                this.filterBy = {
                    field: 'idPlanUnidad',
                    value: this.unit.id,
                };
            },
            dayMonthFormat(value){
                return moment(value.split('T')[0], 'YYYY-MM-DD').locale('es').format('DD/MM')
            }
        },
        components: {
            RomaMessageModal,
            RomaPercentage, 
            ChevronDownIcon,
            ChevronUpIcon,
            ArrowLeftIcon
        },
    });

